export default __webpack_public_path__ + "static/media/Ramp8x1.256.819548a4.png";